import React from "react";
import Spinner from "../../Spinner";
import SearchSelect from "../../SearchSelect";

const SelectCustomer = ({ value, onChange, customers }) => {

  if (!customers) {
    return (
      <div className="flex w-full justify-center">
        <Spinner />
      </div>
    );
  }

  const _value = customers.filter(i => i.id === value)[0]

  return (
    <div className="w-56">
      <SearchSelect
        options={customers.map((r) => ({ value: r.id, label: r.name }))}
        value={{value: _value.id, label: _value.name}}
        onChange={(e) => {onChange(e.value)}}
      />
    </div>
  );
};

export default SelectCustomer;
